// extracted by mini-css-extract-plugin
module.exports = {"garden":"garden","living":"living","wedding":"wedding","shadow":"cms-view_shadow__3ZvnQ","cmsItem":"cms-view_cmsItem__1Mpq0"};